import React from 'react';
import { connect } from 'react-redux';
import {
  FormGroup,
  Label,
  Button,
  UncontrolledPopover,
  PopoverHeader,
  PopoverBody,
} from 'reactstrap';
import { BlockPicker, CirclePicker, SliderPicker } from 'react-color';

class ColorPicker extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedColor: '#1c194d',
    };
  }

  componentDidMount() {
    const { id, values } = this.props;
    this.setState({ selectedColor: values.colorStyles[id] });
  }

  handleChangeComplete = (color) => {
    const { id, dispatch } = this.props;

    this.setState({ selectedColor: color.hex });

    dispatch({
      type: 'EDIT_SITE_THEME',
      id,
      value: color.hex,
      categoryType: 'object',
      category: 'colorStyles',
    });
  };

  render() {
    const {
      id,
      children,
    } = this.props;
    const { selectedColor } = this.state;

    return (
      <FormGroup className="font-large">
        <Label for={id} className="font-weight-bold">
          {children}
        </Label>
        <div
          className="d-flex align-items-center"
        >
          <div
            className="w-50 text-center"
            style={{ fontSize: selectedColor ? '1rem' : '.8rem' }}
          >
            {selectedColor || 'None Selected'}
          </div>
          <Button
            id={id}
            type="button"
            block
            style={{
              border: selectedColor ? '2px solid white' : '2px dashed black',
              backgroundColor: selectedColor || 'white',
              opacity: '1',
              height: '30px',
            }}
          >
            {' '}
          </Button>
        </div>
        <UncontrolledPopover trigger="legacy" placement="bottom" target={id}>
          <PopoverHeader>Color Edit</PopoverHeader>
          <PopoverBody>
            <div
              className="d-flex"
              style={{
                backgroundColor: 'white',
                padding: '20px 0px 20px 20px',
                border: '1px solid lightGrey',
                borderRadius: '20px',
              }}
            >
              <BlockPicker
                id={id}
                color={selectedColor}
                onChangeComplete={this.handleChangeComplete}
                triangle="hide"
                colors={[]}
              />
              <div className="px-4">
                <SliderPicker
                  id={id}
                  className="mb-3"
                  color={selectedColor}
                  onChange={this.handleChangeComplete}
                />
                <CirclePicker
                  id={id}
                  color={selectedColor}
                  onChangeComplete={this.handleChangeComplete}
                />
              </div>
            </div>
          </PopoverBody>
        </UncontrolledPopover>
      </FormGroup>
    );
  }
}

const mapStateToProps = (store) => ({
  values: store.sites.values,
});

export default connect(mapStateToProps)(ColorPicker);
